import { AppConstants } from '../app-constants.service';
import { ConfigurationApiService } from '../../generated/api/configuration/configuration.service';

export class CommonSuperComponent {

    constructor(
        protected readonly appConstants: AppConstants,
        protected readonly configurationApiService: ConfigurationApiService
    ) {
    }

    getUrl(resourceIdentifier: string): string {
        let domain: string = window.location.origin;

        if (!domain || !domain.startsWith('http') && !domain.startsWith('https')) {
            domain = this.appConstants.kreditportalUrl;
        }

        return `${domain}${this.appConstants.baseHref}/${resourceIdentifier}`;
    }

    fwKautionsPage() {
        this.configurationApiService.getConfiguration().subscribe(value => {
            document.location.href = value.urlKautionProdukt;
        });
    }

    fwHilfe() {
        this.configurationApiService.getConfiguration().subscribe(value => {
            window.open(value.urlHilfe, '_blank', 'noopener,noreferrer');
        });
    }

}
